import { create } from "zustand";
import type { OtpState } from "./types";

export const useOtpStore = create<OtpState>((set) => ({
  isLoading: false,
  errorMessage: null,
  code: "",
  setCode: (code) => set({ code }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (message) => set({ errorMessage: message }),
  reset: () => set({ isLoading: false, errorMessage: null, code: "" }),
}));
